import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import EmptyStateAction from '@/common/components/EmptyStateAction';
import LightDataGrid from '@/common/components/LightDataGrid';
import styles from '@/modules/financial-details/financial-details.styles';

const FinancialDetailsSection = ({
  title,
  entries,
  fields,
  emptyText,
  actionText,
  onAction,
  getDisplayValue,
  t,
}) => {
  if (!entries.length) {
    return (
      <Box sx={styles.section}>
        <EmptyStateAction
          description={emptyText}
          actionText={actionText}
          onAction={onAction}
        />
      </Box>
    );
  }

  return (
    <Box sx={styles.section}>
      <Box sx={styles.sectionHeader}>
        <Typography sx={styles.sectionTitle}>{title}</Typography>
        <Button
          color="success"
          size="medium"
          startIcon={<EditIcon />}
          onClick={onAction}
          sx={styles.button}
        >
          {t('Edit')}
        </Button>
      </Box>
      <Box sx={styles.dataGridWrap}>
        <LightDataGrid
          rows={entries.map(({ id, value = {} }, index) => ({
            id: id || index,
            ...value,
          }))}
          columns={fields.map(({ labelKey, valueKey }) => ({
            field: valueKey,
            headerName: t(labelKey),
            flex: 1,
            minWidth: 180,
            renderCell: ({ value }) => getDisplayValue(value, valueKey) || '-',
          }))}
        />
      </Box>
    </Box>
  );
};

export default FinancialDetailsSection;
